// eslint-disable-next-line valid-jsdoc
/**
 * 媒资库标签管理API
 */
angular.module('mediaTagManagerModule').service('mediaTagApiService', [
    'trsHttpService',
    '$q',
    function(trsHttpService, $q) {
        let httpServer = trsHttpService.httpServerForMR;

        this.getTagDetail = function(params) {
            let action = 'detail';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            return sendRequest(requestParams);
        };

        this.saveTag = function(params) {
            let action = 'save';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = undefined;
            requestParams.transformRequest = function (data) {
                var formData = new FormData();
                for (var a in data) {
                    if (a === 'files') {
                        if (data[a].length) {
                            for (var i = 0; i < data[a].length; i++) {
                                formData.append(a, data[a][i]);
                            }
                        }
                    } else {
                        formData.append(a, data[a]);
                    }
                }
                return formData;
            };
            // let requestData = getRequestData(params, 'form');
            return sendRequest(requestParams, params);
        };

        this.importTags = function(params) {
            let action = 'import';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = undefined;
            requestParams.transformRequest = function (data) {
                var formData = new FormData();
                for (var a in data) {
                    formData.append(a, data[a]);
                }
                return formData;
            };
            return sendRequest(requestParams, params);
        };

        this.deleteTags = function(params) {
            let action = 'delete';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        };

        this.getTagList = function(params) {
            let action = 'list';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        };

        this.reSortTag = function(params) {
            let action = 'sorting';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        };

        /**
         * [getRequestUrl 获取请求URL]
         *
         * @param   {[type]}  params  [params description]
         * @param   {[type]}  actionType  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getRequestUrl(params, actionType) {
            let mrType = 'meizi';
            let resourceType = 'label';
            let action = actionType || '';
            let urlSend = '?';
            return trsHttpService.getMRURL() + '/' + mrType + '/' + resourceType + '/' + action + urlSend;
        }

        /**
         * [getRequestData 获取请求数据]
         *
         * @param   {[type]}  params  [params description]
         * @param   {[type]}  type    [type description]
         *
         * @return  {[type]}          [return description]
         */
        function getRequestData(params, type) {
            let data = angular.copy(params);
            if (type === 'json') {
                return JSON.stringify(data);
            } else if (type === 'query') {
                let result = '';
                for (let key in data) {
                    result += '&' + key + '=' + data[key];
                }
                return result;
            }
            return data;
        }

        /**
         * [sendRequest 发送请求]
         *
         * @param   {[type]}  requestParams  [requestParams description]
         * @param   {[type]}  requestData    [requestData description]
         * @param   {[type]}  isArrayBuffer    [requestData description]
         *
         * @return  {[type]}                 [return description]
         */
        function sendRequest(requestParams, requestData, isArrayBuffer) {
            let deffered = $q.defer();
            httpServer(requestParams, requestData, isArrayBuffer).then(
                function(data) {
                    deffered.resolve(data);
                },
                function(data) {
                    deffered.reject(data);
                }
            );
            return deffered.promise;
        }
    },
]);
